
import Alerta from "../../components/alerta/Alerta";
import Sidebar from "../../components/sidebar/Sidebar";
import style from "../documentos/Documentos.module.css";
import Paginacao from "../../components/paginacao/Paginacao";
import { useEffect, useState } from "react";
import Topbar from "../../components/topbar/Topbar";
import { Button } from "react-bootstrap";
import { Form } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import DocumentosApi from "../../services/DocumentosApi";
import { MdClose, MdSearch } from "react-icons/md";
import { IoCopy } from "react-icons/io5";
import { FaFileDownload, FaCheck } from "react-icons/fa";
import Loader from "../../components/loader/Loader";
import InputBuscar from "../../components/inputBuscar/InputBuscar";
import { useIsMobile } from "../../components/useIsMobile/UseIsMobile";

function Documentos() {

    const [titulo, setTitulo] = useState();

    const [tituloModal, setTituloModal] = useState("");
    const [urlDocumento, setUrlDocumento] = useState("");
    const [statusTipos, setStatusTipos] = useState([]);

    const [statusdocumento, setstatusdocumento] = useState([]);

    const [tipoArquivoSelecionado, setTipoArquivoSelecionado] = useState("");
    const [Arquivo, setArquivo] = useState();


  const isMobile = useIsMobile();
  const [menuHamburguerAberto, setMenuHamburguerAberto] = useState(!isMobile);

  useEffect(() => {
    setMenuHamburguerAberto(!isMobile);
  }, [isMobile]);

    //Modais para editar e excluir
    const [mostrarModalAdicionar, setMostrarModalAdicionar] = useState(false);


    //Para rodar a tabela, paginação e filtro
    const [DocumentosSelecionado, setDocumentosSelecionado] = useState([]);
    const [quantidadeItens, setQuantidadeItens] = useState(0);
    const [nomeTitulo, setNomeTitulo] = useState("");
    const [statusDocumentoEnum, setStatusDocumentoEnum] = useState(0);
    const [nomeTituloFiltro, setTituloFiltro] = useState("");
    const [statusDocumentoEnumFiltro, setStatusDocumentoEnumFiltro] = useState(0);
    const [paginaAtual, setPaginaAtual] = useState(1);

    //Para exibir o alerta
    const [mostrarAlerta, setMostrarAlerta] = useState(false);
    const [mensagemAlerta, setMensagemAlerta] = useState("");
    const [tipoAlerta, setTipoAlerta] = useState("");
    const [loading, setLoading] = useState(false);

    const location = useLocation();

    //Recebe o Id da pessoa a ser editada
    const [pessoaID] = useState(location.state);




    //Função para filtro de busca
    async function FiltroDocumentos() {
        setNomeTitulo(nomeTituloFiltro);
        setStatusDocumentoEnum(statusDocumentoEnumFiltro);
        setPaginaAtual(1);
        BuscarDocumento();

    }

    //Função para resetar  filtro de busca
    async function ResetarDocumentos() {

        setNomeTitulo("")
        setStatusDocumentoEnum(0);
        setStatusDocumentoEnumFiltro(0);
        setTituloFiltro("");
        setPaginaAtual(1);
        BuscarDocumento();
    }

    //Função para resetar  filtro de busca
    async function ResetarModal() {

        setTituloModal("")
        setUrlDocumento("");
        BuscarDocumento();
    }

    //Função para alterar a página
    async function AlterarPagina(paginaNova) {
        setPaginaAtual(paginaNova);
    }

    //Função para obter todos os status tipo documentos
    async function BuscarStatusTipo() {
        try {
            const status = await DocumentosApi.ListarTipoEnum();

            setStatusTipos(status);
        } catch (error) {
            console.error("Erro ao buscar status tipo documento:", error.response.data);
        }
    }

    //Função para obter todos os status documentoenum
    async function BuscarStatusdocumento() {
        try {
            const status = await DocumentosApi.ListarStatusEnum();

            setstatusdocumento(status);
        } catch (error) {
            console.error("Erro ao buscar status documento:", error.response.data);
        }
    }


    //Função para obter todos os status de turma
    async function BuscarDocumento() {
        try {
            const documento = await DocumentosApi.ObterDocumentoPorPaginacao(paginaAtual, nomeTitulo, statusDocumentoEnum);

            setQuantidadeItens(documento.quantidadeRegistros);
            setDocumentosSelecionado(documento.registros);


        } catch (error) {

            console.error("Erro ao buscar documento:", error.response.data);
        }
    }


    async function Atualizar(doc) {
        try {
            setLoading(true);
            const statusEnum = 2;
            const status = await DocumentosApi.AtualizarStatus(doc, statusEnum);

            setMensagemAlerta("Status atualizado!");
            setTipoAlerta("success");
            exibirAlerta(true);
            BuscarDocumento()

        } catch (error) {

            console.error("Erro ao atualizar documento:", error);
        } finally {
            setLoading(false);
        }
    }


    const BaixarDocumento = async (doc) => {
        try {
            setLoading(true);
            const response = await DocumentosApi.BaixarDocumento(doc);

            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${doc.titulo || "documento"}.pdf`);
            document.body.appendChild(link);
            link.click();
            link.remove();

            setMensagemAlerta("Documento Baixado com sucesso!");
            setTipoAlerta("success");
            exibirAlerta(true);

        } catch (error) {
            setMensagemAlerta(`Erro ao baixar o documento: ${error.response?.data || error.message}`);
            setTipoAlerta("danger");
            exibirAlerta(true)
        } finally {
            setLoading(false);
        }
    };


    const CopiarParaClipboardAlternativo = async (documentoUrl) => {
        try {
            if (navigator.clipboard && navigator.clipboard.writeText) {
                await navigator.clipboard.writeText(documentoUrl);
            } else {

                // Fallback para navegadores antigos
                const input = document.createElement("input");
                input.value = documentoUrl;
                document.body.appendChild(input);
                input.select();

                document.execCommand("copy");
                document.body.removeChild(input);

            }
            setMensagemAlerta("Documento Copiado com sucesso!");
            setTipoAlerta("success");
            exibirAlerta(true);

        } catch (error) {
            console.error("Erro ao copiar o documento:", error);

        }
    };

    function ExibirNomeCertificado(doc, statusTipos) {
        const tipo = statusTipos.find((t) => t.id === doc.statusTipoArquivo);
        if (!tipo) return 'Desconhecido';

        switch (tipo.nome) {
            case 'Arquivo':
                return 'Arquivo';
            case 'LINK':
                return 'Link';
            case 'ArquivoCertificadoMonitoria':
                return 'Certificado Monitoria';
            case 'ArquivoCertificadoCoclusao':
                return 'Certificado Conclusão';
            default:
                return tipo.nome;
        }
    }

    //Função para o fechar modal
    const FecharModal = () => {

        setMostrarModalAdicionar(false);

    };
    const exibirAlerta = () => {
        setMostrarAlerta(true);
        setTimeout(() => {
            setMostrarAlerta(false);
        }, 3000);
    };

    const totalPaginas = Math.ceil(quantidadeItens / 10); //total de paginas com itens filtrados

    useEffect(() => {
        BuscarDocumento()
        BuscarStatusTipo()
        BuscarStatusdocumento()
    }, [pessoaID, paginaAtual, titulo, statusDocumentoEnum, nomeTitulo]);
    return (

        <Sidebar menuHamburguerAberto={menuHamburguerAberto} setMenuHamburguerAberto={setMenuHamburguerAberto}>
            <Topbar
                menuHamburguerAberto={menuHamburguerAberto}
                setMenuHamburguerAberto={setMenuHamburguerAberto}
            >
                <Alerta
                    tipo="success"
                    mensagem={mensagemAlerta}
                    visivel={mostrarAlerta}
                    aoFechar={() => setMostrarAlerta(false)}
                />
                {loading && <Loader />}

                <div className={style.pagina_conteudo}>
                    <div className={style.container_cabecalho}>
                        <h4>Documentos</h4>
                    </div>
                    {/* Filtro de pesquisa */}
                    <div className={style.container_filtro}>


                        <InputBuscar
                            type="text"
                            id="hidenTitulo"
                            placeholder="Nome"
                            name="Nome"
                            value={nomeTituloFiltro}
                            maxLength={30}
                            onChange={(e) => setTituloFiltro(e.target.value)}
                        />
                        <Form.Select
                            value={statusDocumentoEnumFiltro}
                            onChange={(e) => setStatusDocumentoEnumFiltro(e.target.value)}
                        >
                            <option value="">Status</option>
                            {statusdocumento.map((status) => (
                                <option key={status.id} value={status.id}>
                                    {status.nome}

                                </option>
                            ))}
                        </Form.Select>
                        <div className={style.container_filtro2}>
                            <Button onClick={FiltroDocumentos} id={style.botao_buscar}><MdSearch /> Buscar
                            </Button>

                            <Button onClick={ResetarDocumentos} id={style.botao_resetar}><MdClose /> Limpar
                            </Button>
                        </div>

                    </div>
                    <div className={style.container_tabela_paginacao}>
                        <div className={style.tabela_responsiva}>
                            <table className={style.container_tabela}>
                                <thead>
                                    <tr>
                                        <th>Nome</th>
                                        <th>Tipo</th>
                                        <th>Data de envio</th>
                                        <th>Status</th>
                                        <th className={style.coluna_acoes}>Ações</th>
                                    </tr>
                                </thead>
                                <tbody>


                                    {DocumentosSelecionado?.map((doc) => (

                                        <tr className={style.tabela_corpo} key={doc.id}>
                                            <td title={doc.titulo}>{doc.titulo}</td>

                                            <td title={ExibirNomeCertificado(doc, statusTipos)}>
                                                {ExibirNomeCertificado(doc, statusTipos)}
                                            </td>


                                            <td title={doc.dataEnvio}>{new Date(doc.dataEnvio).toLocaleDateString('pt-BR', {
                                                day: '2-digit',
                                                month: '2-digit',
                                                year: 'numeric'

                                            })}{' '}
        
                                            </td>
                                            <td title={statusdocumento.find(s => s.id === doc.statusDocumentoEnum)?.nome}>
                                                <span
                                                    className={`badge ${statusdocumento.find(s => s.id === doc.statusDocumentoEnum)?.nome === "Pendente"
                                                        ? "bg-warning"
                                                        : statusdocumento.find(s => s.id === doc.statusDocumentoEnum)?.nome === "Assinado"
                                                            ? "bg-success"
                                                            : statusdocumento.find(s => s.id === doc.statusDocumentoEnum)?.nome === "Rejeitado"
                                                                ? "bg-danger"
                                                                : "bg-secondary"
                                                        }`}
                                                    style={{ fontSize: "12px", padding: "5px 12px" }}
                                                >
                                                    {statusdocumento.find(s => s.id === doc.statusDocumentoEnum)?.nome}
                                                </span>
                                            </td>

                                            <td className={style.coluna_acoes}>


                                                {doc.statusDocumentoEnum !== 3 && doc.statusTipoArquivo === 2 && doc.statusTipoArquivo !== 4 && (
                                                    <Link
                                                        title="Assinado"
                                                        onClick={() => {
                                                            Atualizar(doc.documentoID);
                                                        }}
                                                        className={style.botao_deletar}
                                                    >
                                                        <FaCheck />
                                                    </Link>
                                                )}

                                                {doc.statusTipoArquivo !== 2 && (
                                                    <Link
                                                        title="Baixar"
                                                        onClick={() => BaixarDocumento(doc.documentoID)}
                                                        className={style.botao_baixar}
                                                    >
                                                        <FaFileDownload />
                                                    </Link>
                                                )}
                                                {doc.statusTipoArquivo === 2 && (
                                                    <Link
                                                        title="Copiar"
                                                        onClick={() => CopiarParaClipboardAlternativo(doc.urlDocumento)}
                                                        className={style.botao_baixar}
                                                    >
                                                        <IoCopy />
                                                    </Link>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <Paginacao
                            id={style.configuracao_paginacao}
                            paginaAtual={paginaAtual}
                            totalPages={totalPaginas}
                            onPageChange={(novaPagina) => AlterarPagina(novaPagina)}
                        />

                    </div>   </div>
            </Topbar>
        </Sidebar>
    )
} export default Documentos;